import React, { FC, createRef, useEffect, useState } from "react";
import Slider from "react-slick";
import st from "./index.module.scss";
import { ProductSlide } from "components/ProductSlide";
import { useScreenSize } from "@pepdirect/helpers/useScreenSize";
import { SliderArrow } from "./SliderArrow";
import { useOnScreen } from "@pepdirect/helpers/useOnScreen";
import { Product } from "@pepdirect/shared/types";
import {
  generateHashedId,
  logProductImpression,
} from "@pepdirect/helpers/analyticsLogger";
import { useGetItemsByGtinsQuery } from "services/graphql/generated";

type DataType = {
  imageUrl: string;
  title: string;
  slug: string;
  gtin: string;
};

const data: DataType[] = [
  {
    imageUrl:
      "https://www.datocms-assets.com/74813/1705412021-46917_ec_front.png",
    title: "white peach",
    slug: "focus-white-peach",
    gtin: "00012000231124",
  },
  {
    imageUrl:
      "https://www.datocms-assets.com/74813/1705412014-46916_ec_front.png",
    title: "lemon lime",
    slug: "focus-lemon-lime",
    gtin: "00012000231131",
  },
  {
    imageUrl:
      "https://www.datocms-assets.com/74813/1705412028-46919_ec_front.png",
    title: "orange pineapple",
    slug: "focus-orange-pineapple",
    gtin: "00012000231148",
  },
];

export const ProductSlider: FC = () => {
  const { isMobile, isTablet } = useScreenSize();
  const { data: pepdirectItemsQuery } = useGetItemsByGtinsQuery({
    variables: {
      gtins: data.map((item) => item.gtin),
    },
  });

  const [hasEventTriggered, setHasEventTriggered] = useState<boolean>(false);
  const ref = createRef<HTMLDivElement>();
  const isVisible = useOnScreen(ref);
  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: isMobile ? 1 : isTablet ? 2 : 3,
    slidesToScroll: 1,
    prevArrow: <SliderArrow isLeft />,
    nextArrow: <SliderArrow />,
    className: st.slider,
  };

  useEffect(() => {
    if (pepdirectItemsQuery && isVisible && !hasEventTriggered) {
      setHasEventTriggered(true);
      const itemListName = "cans|focus landing|carousel|the focus offering";
      const itemListId = generateHashedId(itemListName);
      logProductImpression(
        "",
        data.map((item) => {
          const pepdirectItem = pepdirectItemsQuery?.items?.items.find(
            (pepdirectItem) => pepdirectItem.gtin === item.gtin
          );
          return {
            _id: pepdirectItem?._id || "",
            gtin: item.gtin,
            itemTitle: item.title.toLowerCase(),
            itemSlug: item.slug,
            itemPrice: pepdirectItem?.itemPrice
              ? pepdirectItem.itemPrice / 100
              : null,
            itemDesignerArtistBrandName:
              pepdirectItem?.itemDesignerArtistBrandName || null,
            itemDimensions: pepdirectItem?.itemDimensions || null,
          } as Product;
        }),
        itemListName,
        itemListId
      );
    }
  }, [hasEventTriggered, isVisible, pepdirectItemsQuery]);

  return (
    <div className={st.container} ref={ref}>
      <h1 className={st.header}>the focus offering</h1>
      <Slider {...settings}>
        {data.map((item, index) => {
          return (
            <ProductSlide
              imageUrl={item.imageUrl}
              title={item.title}
              slug={item.slug}
              key={item.title}
              index={index + 1}
              item={
                pepdirectItemsQuery?.items?.items.find(
                  (pepdirectItem) => pepdirectItem.gtin === item.gtin
                ) as Product | undefined
              }
            />
          );
        })}
      </Slider>
    </div>
  );
};
